import TeamCard from './TeamCard';
import { TeamCardProps, TeamCardValueProps } from './types';

export type { TeamCardProps, TeamCardValueProps };
export default TeamCard;
